const initModelSelectLogic = () => {
	var submit = document.getElementById("navigation-submit-btn");
	var options = document.querySelectorAll(".car-selection");
	submit.setAttribute("disabled", true);
	for (let option of options) {
		if (option.querySelector(".is-checked")) {
			submit.removeAttribute("disabled");
		}
		option.addEventListener("click", () => {
			submit.removeAttribute("disabled");
		});
	}
};
export { initModelSelectLogic };
